/* Enum of boot sequence states */
export const BOOT_STATES = {
  INITIAL: "INITIAL",
  STAGE_1: "STAGE_1",
  STAGE_2: "STAGE_2",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};
